import { render, staticRenderFns } from "./MProviderIcon.vue?vue&type=template&id=1d576769"
import script from "./MProviderIcon.vue?vue&type=script&lang=js"
export * from "./MProviderIcon.vue?vue&type=script&lang=js"
import style0 from "./MProviderIcon.vue?vue&type=style&index=0&id=1d576769&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports